import { render, staticRenderFns } from "./videoCom.vue?vue&type=template&id=1db587d4"
import script from "./videoCom.vue?vue&type=script&lang=js"
export * from "./videoCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports